import { IEntregas } from "../global/types"
import { compareInHoursAndMin, minutesToHours } from "./dateProvider"


export const minutosPorPedido = (item: IEntregas): string => {
  const hours = compareInHoursAndMin(`${item.entrada}`, `${item.saida}`).split(":")
  const minutes = parseInt(hours[0]) * 60 + parseInt(hours[1])

  const minutosPedido = minutes / item.pedidos

  return minutesToHours(Math.floor(minutosPedido))
}

export const minutosPorKm = (item: IEntregas): string => {
  const hours = compareInHoursAndMin(`${item.entrada}`, `${item.saida}`).split(":")
  const minutes = parseInt(hours[0]) * 60 + parseInt(hours[1])

  const minutosPedido = minutes / (parseInt(`${item.km_final}`) - parseInt(`${item.km_inicial}`))

  return minutesToHours(Math.floor(minutosPedido))
}

export const dieselGasto = (item: IEntregas): number => {
  const kmRodados = parseInt(`${item.km_final}`) - parseInt(`${item.km_inicial}`)
  const autonomia = parseFloat(`${item.veiculo.autonomia}`)
  const diesel = parseFloat(`${item.valor_diesel}`)

  return ((kmRodados) / autonomia) * diesel
}

export const salarioDia = (item: IEntregas, pessoa: "motorista" | "ajudante"): number => {
  if (pessoa === "ajudante" && !item.ajudante)
    return 0

  const salario = parseFloat(`${item[`salario_${pessoa === "motorista" ? "motor" : "ajud"}`]}`)

  return salario / 30
}

export const totalDiaAjudantes = (item: IEntregas): number => {
  let total = 0

  item.freelancers?.filter(e => e.funcao === 0).forEach((rs) => {
    total += rs.salario ? (parseFloat(`${rs.salario}`) / 30) : 0
  })

  return total
}

export const totalExtraAjudantes = (item: IEntregas): number => {
  let total = 0

  item.freelancers?.filter(e => e.funcao === 0).forEach((rs) => {
    let minutos = 0
    const cargaHoraria = `${rs.carga_hr}`
    const minutosCargaHoraria = parseInt(cargaHoraria.split(":")[0]) * 60 + parseInt(cargaHoraria.split(":")[1])

    const valorHora = parseFloat(`${rs.extra}`)
    const valorMin = valorHora / 60

    const trabalhadas = compareInHoursAndMin(`${item.entrada}`, `${item.saida}`).split(":")
    const minTrabalhados = parseInt(trabalhadas[0]) * 60 + parseInt(trabalhadas[1])

    if (minTrabalhados > minutosCargaHoraria)
      minutos = minTrabalhados - minutosCargaHoraria

    total += minutos * valorMin
  })

  return total
}

export const minutosExtras = (item: IEntregas, pessoa: "motorista" | "ajudante"): number => {
  if (pessoa === "ajudante" && !item.ajudante)
    return 0

  const cargaHoraria = pessoa === "motorista" ? `${item.carga_motor}` : `${item.carga_ajud}`
  const minutosCargaHoraria = parseInt(cargaHoraria.split(":")[0]) * 60 + parseInt(cargaHoraria.split(":")[1])

  const trabalhadas = compareInHoursAndMin(`${item.entrada}`, `${item.saida}`).split(":")
  const minTrabalhados = parseInt(trabalhadas[0]) * 60 + parseInt(trabalhadas[1])

  if (minTrabalhados <= minutosCargaHoraria)
    return 0

  return minTrabalhados - minutosCargaHoraria
}

export const valorHrExtra = (item: IEntregas, minutos: number, pessoa: "motorista" | "ajudante"): number => {
  if (pessoa === "ajudante" && !item.ajudante)
    return 0

  const valorHora = pessoa === "motorista" ? parseFloat(`${item.extra_motor}`) : parseFloat(`${item.extra_ajud}`)
  const valorMin = valorHora / 60

  return minutos * valorMin
}

export const qtdDiarias = (item: IEntregas): number => {
  let qtdDiarias = 1;

  if (item.freelancers)
    qtdDiarias += item.freelancers.filter(e => e.funcao === 0).length

  if (item.ajudante)
    qtdDiarias += 1

  return qtdDiarias
}

export const totalGasto = (item: IEntregas): number => {
  const diarias = parseFloat(`${item.diarias}`) * qtdDiarias(item)
  const balsa = parseFloat(`${item.valor_balsa}`)
  const pedagio = parseFloat(`${item.valor_pedagio}`)
  const diversos = parseFloat(`${item.diversos}`)

  return dieselGasto(item) +
    diarias +
    balsa +
    pedagio +
    diversos +
    salarioDia(item, "motorista") +
    salarioDia(item, "ajudante") +
    valorHrExtra(item, minutosExtras(item, "motorista"), "motorista") +
    valorHrExtra(item, minutosExtras(item, "ajudante"), "ajudante") +
    custoFreelancers(item) +
    totalDiaAjudantes(item) +
    totalExtraAjudantes(item)
}

export const custoKmRodado = (item: IEntregas): number => {
  const kmRodados = parseInt(`${item.km_final}`) - parseInt(`${item.km_inicial}`)
  const custo = totalGasto(item)
  return custo / kmRodados
}

export const custoPorPedido = (item: IEntregas): number => {
  const custo = totalGasto(item)
  return custo / item.pedidos
}

export const porcCusto = (item: IEntregas): number => {
  const total = totalGasto(item)
  const carga = parseFloat(`${item.valor_carga}`)

  return (total / carga) * 100
}

export const custoFreelancers = (item: IEntregas): number => {
  let total = 0

  item.freelancers?.filter(e => e.funcao === 1).forEach(rs => {
    total += parseFloat(`${rs.salario}`)
  })

  return total
}